const NotFound = () => {
    return (
        <section
            className="page-not-found"
            style={{
                minHeight: '100vh',
                width: '100%',
            }}
        >
            <h1>Opps, You are in wrong place!</h1>
        </section>
    )
}

export default NotFound;